export const RequestType = {
  PLAN: '플랜',
  PV_CHARGE: 'PV 충전',
  JAM_CHARGE: 'Jam 충전',
  ADDITIONAL: '부가 서비스'
} as const;

export type RequestTypeKeys = keyof typeof RequestType;
export type RequestTypeValues = typeof RequestType[RequestTypeKeys];

export const optionsReqType = Object.entries(RequestType).map(([key, label]) => ({
  value: key,
  label
}));

const RequestStatuses = {
  CREATED_REQUEST_PLAN: '플랜 생성 대기',
  CREATED_REQUEST_PV: 'PV 충전 대기',
  CREATED_REQUEST_JAM: 'Jam 충전 대기',
  CREATED_REQUEST_ADDITIONAL: '부가 서비스 처리 대기',
  DAY_PAYMENT_WIRE: '무통장 입금 대기',
  DAY_PAYMENT_WIRE_DELAY: '무통장 입금 지연',
  DAY_PAYMENT_CARD: '카드 결제 대기',
  DAY_INVOICE_TAX: '세금 계산서 발행',
  DAY_INVOICE: '서류 발행',
  NEED_TO_EXTEND: '플랜 연장 필요',
  NON_ISSUE: '이슈 없음',
  COMPLETED_REQUEST: '리퀘스트 종료',
} as const;

export const RequestStatus = RequestStatuses;

export type RequestStatusKeys = keyof typeof RequestStatuses;
export type RequestStatusValues = typeof RequestStatuses[RequestStatusKeys];

export const RequestActiveStatus = {
  CREATED_REQUEST_PLAN: RequestStatuses.CREATED_REQUEST_PLAN,
  CREATED_REQUEST_PV: RequestStatuses.CREATED_REQUEST_PV,
  CREATED_REQUEST_JAM: RequestStatuses.CREATED_REQUEST_JAM,
  CREATED_REQUEST_ADDITIONAL: RequestStatuses.CREATED_REQUEST_ADDITIONAL,
  DAY_PAYMENT_WIRE: RequestStatuses.DAY_PAYMENT_WIRE,
  DAY_PAYMENT_WIRE_DELAY: RequestStatuses.DAY_PAYMENT_WIRE_DELAY,
  DAY_PAYMENT_CARD: RequestStatuses.DAY_PAYMENT_CARD,
  DAY_INVOICE_TAX: RequestStatuses.DAY_INVOICE_TAX,
  DAY_INVOICE: RequestStatuses.DAY_INVOICE,
  NEED_TO_EXTEND: RequestStatuses.NEED_TO_EXTEND,
};

export type RequestActiveStatusKeys = keyof typeof RequestActiveStatus;
export type RequestActiveStatusValues = typeof RequestActiveStatus[RequestActiveStatusKeys];

export const PaymentType = {
  free: '무상',
  wire: '무통장',
  card: '카드'
} as const;

export type PaymentTypeKeys = keyof typeof PaymentType;
export type PaymentTypeValues = typeof PaymentType[PaymentTypeKeys];

export const DocumentType = {
  TAX_INVOICE: '세금계산서',
  QUOTATION: '견적서',
  CONTRACT: '계약서',
  INVOICE: '청구서',
  TRANSACTION: '거래명세서',
  SETTLEMENT: '정산요청서'
} as const;

export type DocumentTypeKeys = keyof typeof DocumentType;
export type DocumentTypeValues = typeof DocumentType[DocumentTypeKeys];

export const optionsDocumentType = Object.entries(DocumentType).map(([key, label]) => ({
  value: key,
  label
}));

export type Document = {
  docType: DocumentTypeKeys,
  actionDate: string,
  email: string[],
  periodic?: boolean | null,
  isEndOfMonth?: boolean
}

export type Documents = Document[] | null

export const PaymentCycleType = {
  0: '일시납',
  1: '월납',
  2: '격월납',
  3: '분기납',
  4: '4개월납',
  6: '반기납',
  12: '연납'
} as const;

export type PaymentCycleTypeKeys = keyof typeof PaymentCycleType;
export type PaymentCycleTypeValues = typeof PaymentCycleType[PaymentCycleTypeKeys];

export const LogMessages = {
  CREATED_REQUEST_PLAN: '리퀘스트 생성, 상태 추가 (플랜 생성 대기)',
  CREATED_EAGLE_PLAN: '플랜 생성 완료, 상태 제거 (플랜 생성 대기)',
  CREATED_REQUEST_PV: '리퀘스트 생성, 상태 추가 (PV 충전 대기)',
  CREATED_EAGLE_PV: 'PV 충전 완료, 상태 제거 (PV 충전 대기)',
  CREATED_REQUEST_JAM: '리퀘스트 생성, 상태 추가 (Jam 충전 대기)',
  CREATED_EAGLE_JAM: 'Jam 충전 완료, 상태 제거 (Jam 충전 대기)',
  CREATED_REQUEST_ADDITIONAL: '리퀘스트 생성, 상태 추가 (부가 서비스 처리 대기)',
  PROCESSED_REQUEST_ADDITIONAL: '부가 서비스 처리 완료, 상태 제거  (부가 서비스 처리 대기)',
  DAY_PAYMENT_WIRE: '상태 추가 (무통장 입금 대기)',
  DAY_PAYMENT_WIRE_DELAY: '상태 변경 (무통장 입금 대기 → 무통장 입금 지연)',
  COMPLETED_PAYMENT_WIRE: '입금 확인 완료, 상태 제거 (무통장 입금 대기)',
  COMPLETED_PAYMENT_WIRE_DELAY: '입금 확인 완료, 상태 제거 (무통장 입금 지연)',
  DAY_PAYMENT_CARD: '상태 추가 (카드 결제 대기)',
  COMPLETED_PAYMENT_CARD: '카드 결제 완료, 상태 제거 (카드 결제 대기 )',
  DAY_INVOICE_TAX: '상태 추가 (무통장 세금 계산서 발행 대기)',
  COMPLETED_INVOICE_TAX: '세금 계산서 발행 완료, 상태 제거 (무통장 세금 계산서 발행 대기)',
  DAY_INVOICE: '상태 추가 (기타 서류 발행 대기)',
  COMPLETED_INVOICE: '기타 서류 발행 완료, 상태 제거 (기타 서류 발행 대기)',
  NEED_TO_EXTEND: '상태 추가 (플랜 연장 필요)',
  DONT_NEED_TO_EXTEND: '플랜 연장 미진행, 상태 제거 (플랜 연장 필요)',
  CREATED_NEW_REQUEST: '신규 리퀘스트 생성 완료, 상태 제거 (플랜 연장 필요)',
  COMPLETED_REQUEST: '리퀘스트 종료'
} as const;

export type LogMessagesKeys = keyof typeof LogMessages;
export type LogMessagesValues = typeof LogMessages[LogMessagesKeys];

export const TaxInfoType = {
  EMAIL: '이메일',
  SYSTEM: '시스템'
} as const

export type TaxInfoTypeKeys = keyof typeof TaxInfoType;
export type TaxInfoTypeValues = typeof TaxInfoType[TaxInfoTypeKeys];